import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { userAuth, setFilterOptionsAction } from "../redux/actions/index";
// import { getConfigSettings } from "../Config";
import { PublicClientApplication } from "@azure/msal-browser";
import DrivewayLogo from "./driway.jpg";
import axios from "axios";

const hostUrl = process.env.REACT_APP_HOST ? process.env.REACT_APP_HOST : "";

const styles = (theme) => ({
  root: {
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "left",
    //border: "1px solid red",
    margin: "1rem",
    width: "95%",
    height: "85vh",
    fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri`,
  },
  form: {
    width: "430px",
    //margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    background: "white",
    padding: "20px",
    marginTop: "50px",
    borderRadius: "5px",
  },
  textField: {
    display: "flex",
    width: "100%",
    marginBottom: "0.5rem",
  },
});

class Login extends Component {
  constructor(props) {
    super(props);    
    this.state = {
      name: "",
      email: "",
      // fullNameError : false,
      // emailError : false,
      // fullNameErrorText : "",
      // emailErrorText : "",

      isAuthenticated: false,
    };

    //initialize configuration for microsoft azure login
  }

  // handleChangeName = (e) => {
  //   this.setState({ [e.target.name]: e.target.value });
  //    this.isValidName(e.target.value);
  // };

  // handleChangeEmail = (e) => {
  //   this.setState({ [e.target.name]: e.target.value });
  //   this.isValidEmail(e.target.value);
  // };

  // isValidName = (name = this.state.name) => {
  //   let isValid = true;
  //   if (name.trim().length === 0)
  //   {
  //       this.setState({fullNameError:true, fullNameErrorText:"Please enter full name"});
  //       isValid=false;
  //   }
  //   else if (name.trim().match(/[%<>\\$'"~!@#^&*()_+.,;:?{}]/))
  //   {
  //     this.setState({fullNameError:true, fullNameErrorText:"Full name is not valid. Special characters are not allowed"});
  //     isValid=false;
  //   }
  //   else if (/[0-9]/.test(name.trim())) {
  //     this.setState({fullNameError:true, fullNameErrorText:"Full name is not valid. Numbers are not allowed"});
  //     isValid=false;
  //   }
  //   else
  //   {
  //     this.setState({fullNameError:false, fullNameErrorText:""});
  //   }
  //   return isValid;
  // }

  // isValidEmail = (email = this.state.email) => {
  //   let isValid = true;
  //   if (email.trim().length === 0)
  //   {
  //       this.setState({emailError:true, emailErrorText:"Please enter email id"});
  //       isValid=false;
  //   }
  //   else if (!(/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())))
  //   {
  //     this.setState({emailError:true, emailErrorText:"Email is not valid"});
  //     isValid=false;
  //   }
  //   else
  //   {
  //     this.setState({emailError:false, emailErrorText:""});
  //   }
  //   return isValid;
  // }

  handleLogin = () => {
    //this.login()
    // let isNameValid,isEmailValid = true;
    // isNameValid = this.isValidName();
    // isEmailValid = this.isValidEmail();
    // if (!isNameValid || !isEmailValid ) return;
    // const detailsObj = {
    //   name: this.state.name,
    //   email: this.state.email.toLowerCase(),
    // };
    // this.props.setFilterOptionsAction(detailsObj);
    // /*Swal.fire({
    //   position: "center",
    //   icon: "success",
    //   title: `Logged In`,
    //   showConfirmButton: false,
    //   timer: 1500,
    // });*/
    // this.props.history.push("/");
  };

  componentDidMount() {
    if (
      this.props.user.name.trim() !== "" ||
      this.props.user.email.trim() !== ""
    ) {
      this.props.history.push("/");
    } else if (
      !this.props.user.login ||
      (this.props.user.login &&
        (this.props.user.name.trim() === "" ||
          this.props.user.email.trim() === ""))
    ) {
      this.login();      
      }
    }  

  componentDidUpdate(prevProps, prevState) {
    // console.log("login flag prev", prevProps.user.login);
    // console.log("login flag current", this.props.user.login);
    if (
      this.props.user.login &&
      prevProps.user.login !== this.props.user.login
    ) {
      this.login();
    }
  }

  async login() {
    try {
      const payload = {
        client: true,
      };

      let configValues = [];
      await axios
        .post(`${hostUrl}/api/getConfigData`, payload)
        .then((result) => {
          //console.log("fetching config data", result.data);
          configValues =
            result.data.length > 0 ? result.data[0].value.split(";") : [];
        })
        .catch((err) => {
          console.log("Error in fetching login config data", err.message);
          const detailsObj = {
            name: "",
            email: "",
            //login: false,
          };
          this.props.setFilterOptionsAction(detailsObj);          
        });

      if (configValues.length > 0) {
        //console.log("configValues", configValues);
        this.publicClientApplication = new PublicClientApplication({
          auth: {
            clientId: configValues[0],
            redirectUri: configValues[1],
            authority: configValues[2],
          },
          cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: true,
          },
        });

        //console.log("public client", this.publicClientApplication);
        let result = await this.publicClientApplication.loginPopup({
          scopes: ["user.read"],
          prompt: "select_account",
        });
        this.setState({
          isAuthenticated: true,
          name: result.account.name,
          email: result.account.username,
        });
        // console.log(
        //   "succesfully login through azure name",
        //   result.account.name
        // );
        // console.log(
        //   "succesfully login through azure email",
        //   result.account.username
        // );
        const detailsObj = {
          name: result.account.name,
          email: result.account.username,
          login: false,
          logout: false,
        };
        this.props.setFilterOptionsAction(detailsObj);
        this.props.history.push("/");
      }
    } catch (err) {
      this.setState({ isAuthenticated: false, name: "", email: "" });
      console.log("error at login through azure", err);
      const detailsObj = {
        name: "",
        email: "",
        //login: false,
      };
      this.props.setFilterOptionsAction(detailsObj);      
    }
  }

  logout() {
    this.publicClientApplication.logoutPopup();
  }

  render() {
    const { classes } = this.props;
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          width: "100%",
          height: "90%",
          overflow: "hidden",
          background: "#E5E7E9",
        }}
      >
        <img
          src={DrivewayLogo}
          width="30%"
          height="50%"
          style={{ margin: "auto" }}
        />
        {/* <div className={classes.form}>
          <div className={classes.textField}>
            <TextField
              id="name"
              name="name"
              label="Full Name"
              value={this.state.name}
              onChange={this.handleChangeName}
              style={{ width: "100%" }}
              required
              error = {this.state.fullNameError}
              helperText ={this.state.fullNameError && this.state.fullNameErrorText}
            />
          </div>
          <div className={classes.textField}>
            <TextField
              id="email"
              name="email"
              label="Email Id"
              value={this.state.email}
              onChange={this.handleChangeEmail}
              style={{ width: "100%" }}
              error = {this.state.emailError}
              helperText ={this.state.emailError && this.state.emailErrorText}
              required
            />
          </div>
          <Button variant="contained" onClick={this.handleLogin}>
            Log in
          </Button>
        </div> */}
        {/* <div className={classes.form}>
         <Button variant="contained" onClick={this.handleLogin}>
            Log in
          </Button>
          </div> */}
      </div>
    );
  }
}

const mstp = (state) => {
  return {
    user: state.user,
    filterData: state.filterData,
  };
};

export default connect(mstp, { userAuth, setFilterOptionsAction })(
  withStyles(styles, { withTheme: true })(Login)
);
